<template>
  <div class="box">
    <div class="boxContent">
      <div class="box_left">
        <img src="../assets/imgs/logo.svg" alt="" />
        <span class="title">咖德保安 </span>
      </div>
      <div class="box_content">
        <div
          v-for="(item, index) in list1"
          :key="index"
          @click="selectPage(item)"
          :class="['content_item', item.name == selectData1 ? 'active' : '']"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="box_right">
        <div class="xiaoxi">
          <el-tooltip>
            <div slot="content"><div style="cursor: pointer;">通知</div></div>
            <el-badge is-dot style="width:24px;height: 24px;">
              <img
                src="../assets/imgs/xiaoxi.png"
                alt=""
                style="width:24px;height:24px;margin-right: 4px;"
              />
            </el-badge>
          </el-tooltip>
        </div>
        <el-tooltip>
          <div slot="content">
            <div
              v-for="(item, index) in list2"
              :key="index"
              style="padding: 6px 4px;cursor: pointer;"
              @click="selectStatus(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <img
            src="../assets/imgs/user_img.png"
            alt=""
            style="width:24px;height:24px;margin:0 16px;z-index: 999;"
          />
        </el-tooltip>
        <span>{{ userName }}</span>
      </div>
      <el-dialog
        title="修改密码"
        :visible.sync="dialogFormVisible"
        width="600px"
      >
        <el-form
          label-position="right"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          style="margin: 0 auto;"
        >
          <el-form-item label="原密码" prop="oldPass">
            <el-input
              v-model="ruleForm.oldPass"
              placeholder="请输入"
              style="width: 280px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPass">
            <el-input
              v-model="ruleForm.newPass"
              style="width: 280px;"
              placeholder="至少8位，数字+字母"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPass">
            <el-input
              v-model="ruleForm.confirmPass"
              style="width: 280px;"
              placeholder="再次输入"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list1: [
        // { name: "工作台", path: "/index" },
        // { name: "用户管理", path: "/user" },
        // { name: "保安管理", path: "/askari" },
        // { name: "任务管理", path: "/task" },
        // { name: "运营管理", path: "/operate" },
        // { name: "财务管理", path: "/finance" },
        // { name: "客服管理", path: "/customer" },
        // { name: "系统管理", path: "/system" }
      ],
      selectData1: "",
      list2: [
        { name: "退出登录", id: "1" },
        { name: "修改密码", id: "2" }
      ],
      dialogFormVisible: false,
      ruleForm: {
        oldPass: "",
        newPass: "",
        confirmPass: ""
      },
      rules: {
        oldPass: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPass: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmPass: [
          { required: true, message: "请再次输入新密码", trigger: "blur" }
        ]
      },
      userName: ""
    };
  },
  created() {
    this.list1 = JSON.parse(localStorage.getItem("rule"));
    let val = this.$route.path;
    for (var i = 0; i < this.list1.length; i++) {
      if (val == this.list1[i].url) {
        this.selectData1 = this.list1[i].name;
      } else {
        if (this.list1[i].children) {
          for (var x = 0; x < this.list1[i].children.length; x++) {
            if (val == this.list1[i].children[x].url) {
              this.selectData1 = this.list1[i].name;
            }
            if (this.list1[i].children[x].children) {
              for (
                var y = 0;
                y < this.list1[i].children[x].children.length;
                y++
              ) {
                if (val == this.list1[i].children[x].children[y].url) {
                  this.selectData1 = this.list1[i].name;
                }
              }
            }
          }
        }
      }
    }
    this.userName = localStorage.getItem("USERNAME");
  },
  mounted() {},
  watch: {
    $route(to, from) {
      let val = to.path;
      for (var i = 0; i < this.list1.length; i++) {
        if (val == this.list1[i].url) {
          this.selectData1 = this.list1[i].name;
        }
      }
    }
  },
  methods: {
    selectPage(val) {
      this.selectData1 = val.name;
      let str = val.url;
      if (val.url == "/index") {
        this.$router.push(val.url);
      } else {
        for (var i = 0; i < this.list1.length; i++) {
          if (str == this.list1[i].url) {
            this.$router.push(this.list1[i].children[0].url);
          }
        }
      }
    },
    selectStatus(val) {
      if (val.id == "1") {
        localStorage.clear();
        this.$router.push("/login");
      } else {
        this.dialogFormVisible = true;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = {
            newPassword: this.ruleForm.newPass,
            newPassword2: this.ruleForm.confirmPass,
            oldPassword: this.ruleForm.oldPass
          };
          this.$axios
            .post(`/admapi/sys/users/changePassword`, param)
            .then(({ data }) => {
              this.$router.push("/login");
            })
            .catch()
            .finally((this.dialogFormVisible = false));
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.boxContent {
  width: 1336px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 100%;
}
.box {
  width: 100%;
  height: 64px;
  padding: 0 16px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.box:hover {
  background: #fff;
}
.box_left {
  display: flex;
  align-items: center;
}
.box_left img {
  width: 25px;
  height: 25px;
}
.title {
  margin-left: 9px;
  font-family: AlimamaShuHeiTi-Bold, AlimamaShuHeiTi;
  font-size: 18px;
  font-weight: bold;
}
.title img {
  width: 100%;
  height: 100%;
}
.el-dropdown {
  height: 20px;
  font-size: 18px;
  margin: 0 auto;
}
.box_content {
  display: flex;
  overflow: hidden;
  margin-left: 43px;
}
.content_item {
  font-size: 14px;
  color: #555960;
  margin-right: 32px;
  cursor: pointer;
}
.active {
  color: #2f74ff;
  font-weight: 500;
}
.dropdown {
  text-align: center;
  padding: 0 14px;
  box-sizing: border-box;
  height: 38px;
  background: #e3ecfb;
  border-radius: 4px 4px 4px 4px;
  color: #3a82ef;
  font-size: 9px;
  line-height: 38px;
}
.dropdown1 {
  text-align: center;
  padding: 0 14px;
  box-sizing: border-box;
  height: 38px;
  background: #3a82ef;
  border-radius: 4px 4px 4px 4px;
  color: #fff;
  font-size: 7px;
  line-height: 38px;
  margin-right: 14px;
}
.box_right {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.xiaoxi {
  padding-right: 16px;
  box-sizing: border-box;
  border-right: 1px solid #bedaff;
}
</style>
